export const NewsCategories = [
  { label: "All", value: "all" },
  { label: "Cryptocurrency", value: "cryptocurrency,crypto" },
  { label: "Blockchain", value: "blockchain" },
  { label: "NFT", value: "nft" },
  { label: "Web3", value: "web3" },
  { label: "Business", value: "business" },
]
